import { Pipe, PipeTransform } from '@angular/core';

import { AutocompletePlace } from '@shared/base-search-bar/entities/autocomplete';

@Pipe({
  name: 'airportsVm',
  pure: false,
  standalone: false
})

export class AirportsVmPipe implements PipeTransform {

  transform(cities: AutocompletePlace[], airports: AutocompletePlace[] = []): AutocompletePlace[] {
    if (cities.length > 0) {
      const citiesCollection = cities.map(city => ({
        ...city,
        airports: airports.filter(airport =>
          airport.related_city === city.related_city && airport.country === city.country)
      }));
      const airportsInCitiesMatrix = citiesCollection.map(city => city.airports);
      const airportsInCities = [].concat(...airportsInCitiesMatrix);
      return airports.filter(airport =>
        airportsInCities.every(airInCity => airInCity.code !== airport.code));
    } else return airports;
  }

}
